import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { GET_SESSIONS_QUERY_KEY } from '../queries/useGetSessions';
import UserService from '../Services/users/UserService';
export const useTerminateSession = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (deviceIdentifier) => UserService.terminateSessionByDevice(deviceIdentifier),
    onSuccess: (response) => {
    queryClient.invalidateQueries([GET_SESSIONS_QUERY_KEY]);
    toast.success(response);
    },
    onError: (error) => {
    toast.error(`Échec de la terminaison : ${error.message}`);
    },
  });
  };